import styled from 'styled-components';

export const Field = styled.div`
  margin: 3px 0;
  width: 100%;
`;

export const FlexField = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  column-gap: 0.75rem;
  @media (max-width: 450px) {
    flex-direction: column;
    width: 100%;
  }
`;
